import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { showTokenExpiredAlert, getConfig, authHeader, getCustId, isApiSuccess } from "utils";

// GET subscriber/getExpiredPlanList/{custId} -> dataList
export const planHistoryList = createAsyncThunk('planHistory/list', async ({ navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `subscriber/getExpiredPlanList/${getCustId()}`,
            headers: authHeader()
        })
        return res
    } catch (error) {
        return error.response
    }
})

const planHistory = createSlice({
    name: 'planHistory',
    initialState: {
        list: [],
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(planHistoryList.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(planHistoryList.fulfilled, (state, action) => {
            state.loading = false;
            if (isApiSuccess(action?.payload)) {
                state.list = action.payload.data.dataList || [];
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else {
                state.list = []
            }
        });
        builder.addCase(planHistoryList.rejected, (state) => {
            state.loading = false;
        });
    }
})

export default planHistory.reducer;
